var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrameInspect = function SvgFrameInspect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e8eaed",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450-420q38 0 64-26t26-64-26-64-64-26-64 26-26 64 26 64 64 26m193 160L538-365q-20 13-42.5 19t-45.5 6q-71 0-120.5-49.5T280-510t49.5-120.5T450-680t120.5 49.5T620-510q0 23-6.5 45.5T594-422l106 106zM200-120q-33 0-56.5-23.5T120-200v-160h80v160h160v80zm400 0v-80h160v-160h80v160q0 33-23.5 56.5T760-120zM120-600v-160q0-33 23.5-56.5T200-840h160v80H200v160zm640 0v-160H600v-80h160q33 0 56.5 23.5T840-760v160z"
  })));
};
export default SvgFrameInspect;